/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Other_GroupInputs */

const vi_carrier_legacy_other_group = /** @type {(inputs: Carrier_Legacy_Other_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xã khác cùng huyện`)
};

/**

* @param {Carrier_Legacy_Other_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_other_group = /** @type {((inputs?: Carrier_Legacy_Other_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Other_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_other_group(inputs)
});